<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'BU Page',
          to: {
            name: 'BUPage'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'BUPageEdit',
            params: {
              id: $route.params.id,
            },
            query: {
              section: $route.query.section,
            },
          }
        },
        {
          name: 'QuikTips Detail Edit',
          to: {
            name: 'QuikTipsDetailPage',
            params: {
              id: $route.params.id,
            },
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>

    <div class="page-actions">
      <h2>編輯 BU Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <div class="block mb-5">
      <!-- TechnologyTitle -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"
          ><h4>TechnologyTitle</h4></label
        >
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="quiktipsDetail.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Cover Photo</h4>
          <div class="h5 ink-02-medium--text">
            呈現於BU Page及Overview Page <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="quiktipsDetail.cover_photo"
            dir="quiktips"></ImgUploader>
        </div>
      </div>
      <!-- Detail Page Title -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"
          ><h4>Detail Page Title</h4></label
        >
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="quiktipsDetail.detail_page_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Detail Page Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Detail Page置頂區 <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="quiktipsDetail.detail_page_banner"
            dir="quiktips"></ImgUploader>
        </div>
      </div>
      <!-- Recommended Product -->
      <div class="form-item d-flex px-5 py-5">
        <h4 class="w-240px mr-5">Recommended Product</h4>
        <div class="flex-grow-1 my-n2">
          <!-- 順位 -->
          <div
            class="d-flex mb-10px"
            v-for="(product, i) in recommendProducts"
            :key="i"
          >
            <div
              class="h4"
              :style="{
                width: '100px',
                height: '40px',
                padding: '8px 12px',
                border: '1px solid #d7dee7',
                'border-top-left-radius': '8px',
                'border-bottom-left-radius': '8px',
                'border-right': '1px solid transparent',
              }"
            >
              第 {{ i + 1 }} 順位
            </div>
            <div class="quicktips-autocomplete flex-grow-1">
              <v-autocomplete
                v-model="quiktipsDetail.recommended_product[i]"
                :items="allProducts.map((i) => i.productName)"
                placeholder="以Model Name 或 Product Name搜尋"
                outlined
                dense
              >
                <template v-slot:item="data">
                  <div class="py-14px h5">{{ data.item }}</div>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組 <br />
          於前台左圖右字、右圖左字交錯排版
        </div>
      </div>
      <!-- content-body -->
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in quiktipsDetail.content" :key="item.id">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(i)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>
          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- img uploader -->
          <div class="form-item d-flex px-5 py-5">
            <div class="w-180px">
              <h4 class="mb-10px">Visual</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                dir="quiktips"></ImgUploader>
            </div>
          </div>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content Section</span>
          </button>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="cancelHandler">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="saveHandler">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    ImgUploader,
    Breadscrumbs,
  },
  data: () => ({
    dir: 'quiktips',
    values: '',
    recommendProducts: ['', '', '', ''],
    allProducts: [
      {
        id: '001',
        modalName: 'XPG SUMMONER 召喚師電競鍵盤 (SUMMONER)',
        productName: 'XPG SUMMONER 召喚師電競鍵盤 (SUMMONER)',
      },
      {
        id: '002',
        modalName: 'XPG SUMMONER 召喚師電競滑鼠 (SUMMONERMOUSE)',
        productName: 'XPG SUMMONER 召喚師電競滑鼠 (SUMMONERMOUSE)',
      },
      {
        id: '003',
        modalName: 'XPG SUMMONER 召喚師電競檯燈 (SUMMONER-Lighting)',
        productName: 'XPG SUMMONER 召喚師電競檯燈 (SUMMONER-Lighting)',
      },
    ],
  }),
  computed: {
    ...mapState('bupage', ['bu', 'quiktipsDetail']),
  },
  methods: {
    ...mapActions('bupage', ['setQuicktipsDetail']),
    addItem() {
      const template = {
        title: '',
        description: '',
        visual: '',
      };
      this.quiktipsDetail.content.push(template);
    },
    deleteItem(index) {
      this.quiktipsDetail.content.splice(index, 1);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      if (this.bu == null) {
        return;
      }
      this.setQuicktipsDetail(this.quiktipsDetail);
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
// .v-autocomplete
//   .v-input__control
//     .v-input__slot
//       fieldset
//         legend
//           span
//       .v-select__slot
//         input
//         .v-input__append-inner
//           .v-input__icon
//             i.v-icon
//               ::before, ::after
//         input[type=hidden, value="apple"]
//       .v-menu
//     .v-text-field__detils
//       .v-messages
//         .v-messages__wrapper

// v-autocomplete
.quicktips-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
